import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import styles from './styles.module.css';

// Starting point
import SelectForm from './forms/select-form';

// Specific forms
import GeneralForm from './forms/general-form';
import ImageForm from './forms/image-form';
import MemoryForm from './forms/memory-form';
import NewItemForm from './forms/new-item-form';
import EditItemForm from './forms/edit-item-form';

import submissionRequestHandler from './submissionRequestHandler';

// Submitting states
import Submitting from './state-pages/submitting';
import SubmissionSuccessful from './state-pages/submission-successful';
import SubmissionFailed from './state-pages/submission-failed';

const freezeBodyScroll = addClass =>
  addClass
    ? setTimeout(
        () =>
          document.getElementById('wf-content').classList.add('content-hide'),
        250
      )
    : document.getElementById('wf-content').classList.remove('content-hide');

const forms = {
  [null]: SelectForm,
  general: GeneralForm,
  memory: MemoryForm,
  images: ImageForm,
  newItem: NewItemForm,
  editItem: EditItemForm
};

const a = (action, label) =>
  ga('send', {
    hitType: 'event',
    eventCategory: 'ContributionForm',
    eventAction: action,
    eventLabel: label
  });

export default class ContributionForm extends Component {
  state = {
    form: null,
    open: false,

    submitting: false,
    formData: null,
    recoveryState: null,

    submitted: false,
    submissionSuccessful: null,
    errorCode: null
  };

  componentWillMount() {
    a('OpenForm', this.props.form);
    this.setState({ form: this.props.form });
    freezeBodyScroll(true);
  }

  componentDidMount() {
    setTimeout(() => this.setState({ open: true }), 0);
  }

  componentWillUnmount() {
    a('CloseForm', this.state.form);
    freezeBodyScroll(false);
  }

  setForm = form => {
    a('SelectForm', form);
    this.setState({ form });
  };
  clearForm = form =>
    this.setState({
      form: null,
      formData: null,
      recoveryState: null
    });

  closeForm = () => {
    freezeBodyScroll(false);
    this.setState({ open: false });
    setTimeout(this.props.closeForm, 250);
  };

  submitForm = (formData, recoveryState) => {
    a('SubmitForm', this.state.form);
    this.setState({
      submitting: true,
      formData,
      recoveryState
    });

    submissionRequestHandler(this.state.form, this.props.itemId, formData).then(
      result => {
        if (result === true) {
          a('SubmissionSuccessful', this.state.form);
        } else if (result && result.errorCode === 'REQUEST_TOO_LARGE') {
          a('SubmissionFailed-RequestTooLarge', this.state.form);
        } else {
          a('SubmissionFailed-GenericError', this.state.form);
        }

        this.setState({
          submitting: false,
          submitted: true,
          submissionSuccessful: result === true,
          errorCode:
            result === true ? null : result.errorCode || 'GENERIC_ERROR'
        });
      }
    );
  };

  backToForm = () => {
    a('BackToInput', this.state.form);
    this.setState({
      submitted: false,
      submissionSuccessful: null,
      errorCode: null
    });
  };

  retrySubmission = () => {
    a('RetrySubmission', this.state.form);
    this.submitForm(this.state.formData, this.state.recoveryState);
  };

  render() {
    return ReactDOM.createPortal(
      this.renderForm(),
      document.getElementById('wf-modals')
    );
  }

  renderForm() {
    const {
      submitting,
      submitted,
      submissionSuccessful,
      errorCode
    } = this.state;

    return (
      <div
        className={classnames(
          styles.container,
          this.state.open && styles.isOpen
        )}
      >
        <div className={styles.scrollContainer}>
          {(() => {
            if (submitting) {
              return <Submitting />;
            } else if (submitted && submissionSuccessful) {
              return <SubmissionSuccessful closeForm={this.closeForm} />;
            } else if (submitted && !submissionSuccessful) {
              return (
                <SubmissionFailed
                  errorCode={errorCode}
                  backToForm={this.backToForm}
                  retrySubmission={this.retrySubmission}
                />
              );
            } else {
              return React.createElement(forms[this.state.form], {
                form: this.state.form,
                setForm: this.setForm,
                submitForm: this.submitForm,
                clearForm: this.clearForm,
                closeForm: this.closeForm,
                secondaryButtonIsBack: !this.props.form,
                recoveryState: this.state.recoveryState,
                itemId: this.props.itemId
              });
            }
          })()}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/contribution-form/index.js